var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3, _line, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMixedFlowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 35,
    r: 35,
    fill: "#DEF1FC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 31.5,
    width: 7,
    height: 7,
    rx: 1.5,
    transform: "rotate(90 55 31.5)",
    fill: "#1285C7",
    stroke: "#1285C7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 50.5,
    width: 7,
    height: 7,
    rx: 1.5,
    transform: "rotate(90 39 50.5)",
    fill: "#1285C7",
    stroke: "#1285C7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 31.5,
    width: 7,
    height: 7,
    rx: 1.5,
    transform: "rotate(90 39 31.5)",
    fill: "#1285C7",
    stroke: "#1285C7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 12.5,
    width: 7,
    height: 7,
    rx: 1.5,
    transform: "rotate(90 39 12.5)",
    fill: "#1285C7",
    stroke: "#1285C7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 31.5,
    width: 7,
    height: 7,
    rx: 1.5,
    transform: "rotate(90 23 31.5)",
    fill: "#1285C7",
    stroke: "#1285C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 18C36.5 17.4477 36.0523 17 35.5 17C34.9477 17 34.5 17.4477 34.5 18H36.5ZM34.5 18L34.5 50H36.5L36.5 18H34.5Z",
    fill: "#1285C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2649 16.6441C36.6207 16.2217 36.5666 15.5908 36.1441 15.2351C35.7217 14.8793 35.0908 14.9334 34.7351 15.3559L36.2649 16.6441ZM34.7351 15.3559L18.7351 34.3559L20.2649 35.6441L36.2649 16.6441L34.7351 15.3559Z",
    fill: "#1285C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2809 35.6247C52.6259 35.1934 52.556 34.5641 52.1247 34.2191C51.6934 33.8741 51.0641 33.944 50.7191 34.3753L52.2809 35.6247ZM50.7191 34.3753L34.7191 54.3753L36.2809 55.6247L52.2809 35.6247L50.7191 34.3753Z",
    fill: "#1285C7"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 49.5,
    y1: 35,
    x2: 19.5,
    y2: 35,
    stroke: "#1285C7",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2649 15.3559C35.9092 14.9334 35.2783 14.8793 34.8559 15.2351C34.4334 15.5908 34.3793 16.2217 34.7351 16.6441L36.2649 15.3559ZM52.2649 34.3559L36.2649 15.3559L34.7351 16.6441L50.7351 35.6441L52.2649 34.3559Z",
    fill: "#1285C7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2649 34.3559C19.9092 33.9334 19.2783 33.8793 18.8559 34.2351C18.4334 34.5908 18.3793 35.2217 18.7351 35.6441L20.2649 34.3559ZM36.2649 53.3559L20.2649 34.3559L18.7351 35.6441L34.7351 54.6441L36.2649 53.3559Z",
    fill: "#1285C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMixedFlowIcon);
export default __webpack_public_path__ + "static/media/mixed-flow-icon.3584fa19d0ec22f389b520c4a305a85e.svg";
export { ForwardRef as ReactComponent };